// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Review-Home-StageProgressSummary-StageProgressSummary-module__counter";
export { _1 as "counter" }
